import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[sdMinDate]',
  providers: [{ provide: NG_VALIDATORS, useExisting: SdMinDateValidator, multi: true }]
})
export class SdMinDateValidator implements Validator {
  @Input('sdMinDate') minDate: string | Date;
  validate(c: AbstractControl): ValidationErrors {
    const date = c.value || null;
    const minDate = this.minDate || null;
    if (!date) {
      return null;
    }
    if (!minDate) {
      return null;
    }
    if (new Date(Date.parseFrom(date, 'dd/MM/yyyy HH:mm')).getTime() < new Date(minDate).getTime()) {
      return {
        minDate: true
      };
    }
    return null;
  }
}
